var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_182_73678",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_182_73678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 17.4C13.5001 17.4 14.7751 16.875 15.8251 15.825C16.8751 14.775 17.4001 13.5 17.4001 12C17.4001 10.5 16.8751 9.22498 15.8251 8.17498C14.7751 7.12498 13.5001 6.59998 12.0001 6.59998C10.5001 6.59998 9.2251 7.12498 8.1751 8.17498C7.1251 9.22498 6.6001 10.5 6.6001 12C6.6001 13.5 7.1251 14.775 8.1751 15.825C9.2251 16.875 10.5001 17.4 12.0001 17.4ZM12.0048 15.6C11.5683 15.6 11.1488 15.5212 10.7461 15.3637C10.3434 15.2062 9.9781 14.985 9.6501 14.7H14.3751C14.0439 14.985 13.6752 15.2062 13.2688 15.3637C12.8625 15.5212 12.4412 15.6 12.0048 15.6ZM8.7251 13.5C8.64176 13.3666 8.58343 13.225 8.5501 13.075C8.51676 12.925 8.48343 12.7666 8.4501 12.6H15.5501C15.5334 12.7623 15.5043 12.9196 15.4626 13.0717C15.4209 13.2239 15.3584 13.3666 15.2751 13.5H8.7251ZM8.4501 11.4C8.46676 11.2333 8.5001 11.0791 8.5501 10.9375C8.6001 10.7958 8.65843 10.65 8.7251 10.5H15.2751C15.3584 10.6333 15.4168 10.7791 15.4501 10.9375C15.4834 11.0958 15.5168 11.25 15.5501 11.4H8.4501ZM9.6501 9.29998C9.97843 9.01498 10.3441 8.79373 10.7471 8.63623C11.1501 8.47873 11.568 8.39998 12.0008 8.39998C12.4337 8.39998 12.8514 8.47873 13.2541 8.63623C13.6568 8.79373 14.0221 9.01498 14.3501 9.29998H9.6501ZM5.4001 20.4C4.9051 20.4 4.48135 20.2237 4.12885 19.8712C3.77635 19.5187 3.6001 19.095 3.6001 18.6V5.39998C3.6001 4.90498 3.77635 4.48123 4.12885 4.12873C4.48135 3.77623 4.9051 3.59998 5.4001 3.59998H18.6001C19.0951 3.59998 19.5188 3.77623 19.8713 4.12873C20.2238 4.48123 20.4001 4.90498 20.4001 5.39998V18.6C20.4001 19.095 20.2238 19.5187 19.8713 19.8712C19.5188 20.2237 19.0951 20.4 18.6001 20.4H5.4001ZM5.4001 18.6H18.6001V5.39998H5.4001V18.6Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeating);
export default __webpack_public_path__ + "static/media/heating.c14be5a859b5f822da3f3ba67f30606a.svg";
export { ForwardRef as ReactComponent };